var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFamily64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_17773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.658 31.9107C23.5821 31.9107 26.7633 28.7296 26.7633 24.8055C26.7633 20.8813 23.5821 17.7002 19.658 17.7002C15.7339 17.7002 12.5527 20.8813 12.5527 24.8055C12.5527 28.7296 15.7339 31.9107 19.658 31.9107Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6579 31.9106C25.5441 31.9106 30.3158 37.2125 30.3158 43.7528V55.5949H10.1842C9.53019 55.5949 9 55.0647 9 54.4106V43.7528C9 37.2125 13.7717 31.9106 19.6579 31.9106Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1576 25.9896C46.7358 25.9896 50.4471 22.2783 50.4471 17.7001C50.4471 13.122 46.7358 9.41064 42.1576 9.41064C37.5795 9.41064 33.8682 13.122 33.8682 17.7001C33.8682 22.2783 37.5795 25.9896 42.1576 25.9896Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.158 25.9895C48.6982 25.9895 54.0001 32.6169 54.0001 40.7921V54.4106C54.0001 55.0646 53.4699 55.5948 52.8159 55.5948H30.3159V40.7921C30.3159 32.6169 35.6178 25.9895 42.158 25.9895Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_17773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFamily64);
export default __webpack_public_path__ + "static/media/pictogramBeaconFamily64.d938ac0ce91361f76d41ed8afde831ee.svg";
export { ForwardRef as ReactComponent };